import Api from '@/services/Api';
import CustomStore from 'devextreme/data/custom_store';
import EventBus from '@/services/event-bus';

export default {
  namespaced: true,
  state: {
    showReportPopup: false,
    focusedRowKey: null,
    focusedReportRowKey: null,
  },
  actions: {
    async saveAlert({ rootState }, data) {
      try {
        const xhr = await Api.saveSampleAlert(
          data,
          rootState.contact.company,
          rootState.contact.address
        );

        const response = JSON.parse(xhr.response);

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async getReports({ rootState }, params) {
      try {
        const xhr = await Api.getSampleAlertReports(
          params,
          rootState.contact.company,
          rootState.contact.address
        );

        const response = JSON.parse(xhr.response);

        return Promise.resolve({
          data: response.data,
          totalCount: response.totalCount,
        });
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async getElement({ rootState }, id) {
      try {
        const xhr = await Api.getSampleAlertReportById(
          id,
          rootState.contact.company,
          rootState.contact.address
        );

        const response = JSON.parse(xhr.response);

        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async getReportsStoreWithFilters({ dispatch }, paramFilters) {
      return new CustomStore({
        key: 'id',
        load: async (loadOptions) => {
          let params = '?';
          let sortSettings = [];

          ['skip', 'take', 'sort'].forEach((i) => {
            if (i in loadOptions) {
              if (i === 'sort' && loadOptions[i] !== null) {
                sortSettings = loadOptions[i];
              } else {
                params += `${i}=${JSON.stringify(loadOptions[i])}&`;
              }
            }
          });

          params = params.slice(0, -1);
          let subsistuteParams = params.replace('skip', 'offset');
          subsistuteParams = subsistuteParams.replace(
            'take',
            'limit'
          );

          const offsetLimit = subsistuteParams.split('&');
          const offset = offsetLimit[0].split('=')[1];

          const limit = offsetLimit[1].split('=')[1];

          paramFilters.offset = offset;
          paramFilters.limit = limit;

          const sortParams = await dispatch(
            'filter/applySort',
            {
              sortSettings,
              isFilter: true,
            },
            { root: true }
          );

          paramFilters.ordering = sortParams.sort;

          return dispatch('getReports', paramFilters);
        },
        update(key, val) {
          if (key === 'status') {
            return dispatch('updateAlertState', val);
          }

          return null;
        },
      });
    },
    async getAlerts({ rootState }, params) {
      try {
        const xhr = await Api.getSampleAlerts(
          params,
          rootState.contact.company,
          rootState.contact.address
        );
        const response = JSON.parse(xhr.response);

        return Promise.resolve({
          data: response.data,
          totalCount: response.totalCount,
        });
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async updateAlertState({ rootState }, params) {
      try {
        const xhr = await Api.updateAlertState(
          params.id,
          params.newState,
          rootState.contact.company,
          rootState.contact.address,
          true
        );
        const response = JSON.parse(xhr.response);

        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async updateAlert({ rootState }, { id, params }) {
      try {
        const xhr = await Api.updateSampleAlert(
          id,
          params,
          rootState.contact.company,
          rootState.contact.address
        );
        const response = JSON.parse(xhr.response);

        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async deleteAlert({ rootState }, id) {
      try {
        await Api.deleteSampleAlert(
          id,
          rootState.contact.company,
          rootState.contact.address
        );

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async deleteAlertReport({ rootState }, id) {
      try {
        await Api.deleteSampleAlertReport(
          id,
          rootState.contact.company,
          rootState.contact.address
        );

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async duplicateAlert({ rootState }, data) {
      try {
        const xhr = await Api.saveSampleAlert(
          data,
          rootState.contact.company,
          rootState.contact.address
        );

        const response = JSON.parse(xhr.response);

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    getReportsStore({ dispatch }) {
      return new CustomStore({
        key: 'id',
        load: async (loadOptions) => {
          let params = '?';
          let sortSettings = [];

          ['skip', 'take', 'sort'].forEach((i) => {
            if (i in loadOptions) {
              if (i === 'sort' && loadOptions[i] !== null) {
                sortSettings = loadOptions[i];
              } else {
                params += `${i}=${JSON.stringify(loadOptions[i])}&`;
              }
            }
          });

          params = params.slice(0, -1);
          let subsistuteParams = params.replace('skip', 'offset');
          subsistuteParams = subsistuteParams.replace(
            'take',
            'limit'
          );

          const sortParams = await dispatch(
            'filter/applySort',
            {
              sortSettings,
              isFilter: false,
            },
            { root: true }
          );

          subsistuteParams += sortParams;

          return dispatch('getReports', subsistuteParams);
        },
      });
    },
    getStore({ dispatch }) {
      return new CustomStore({
        key: 'id',
        load: async (loadOptions) => {
          let params = '?';
          let sortSettings = [];

          ['skip', 'take', 'sort'].forEach((i) => {
            if (i in loadOptions) {
              if (i === 'sort' && loadOptions[i] !== null) {
                sortSettings = loadOptions[i];
              } else {
                params += `${i}=${JSON.stringify(loadOptions[i])}&`;
              }
            }
          });

          params = params.slice(0, -1);
          let subsistuteParams = params.replace('skip', 'offset');
          subsistuteParams = subsistuteParams.replace(
            'take',
            'limit'
          );

          const sortParams = await dispatch(
            'filter/applySort',
            {
              sortSettings,
              isFilter: false,
            },
            { root: true }
          );

          subsistuteParams += sortParams;

          // return dispatch('getAlerts', subsistuteParams);
          const result = await dispatch(
            'getAlerts',
            subsistuteParams
          );

          // 🔥 CONVERTIR FECHAS STRING → Date
          result.data.forEach((item) => {
            if (
              item.created_at &&
              typeof item.created_at === 'string'
            ) {
              item.created_at = new Date(
                item.created_at.replace(
                  /(\d{2})\/(\d{2})\/(\d{4})/,
                  '$3-$2-$1'
                )
              );
            }

            if (
              item.updated_at &&
              typeof item.updated_at === 'string'
            ) {
              item.updated_at = new Date(
                item.updated_at.replace(
                  /(\d{2})\/(\d{2})\/(\d{4})/,
                  '$3-$2-$1'
                )
              );
            }
          });

          return result;
        },
        update(key, val) {
          if (key === 'status') {
            return dispatch('updateAlertState', val);
          }

          return null;
        },
      });
    },
    async getStoreWithFilters({ dispatch }, paramFilters) {
      return new CustomStore({
        key: 'id',
        load: async (loadOptions) => {
          let params = '?';
          let sortSettings = [];

          ['skip', 'take', 'sort'].forEach((i) => {
            if (i in loadOptions) {
              if (i === 'sort' && loadOptions[i] !== null) {
                sortSettings = loadOptions[i];
              } else {
                params += `${i}=${JSON.stringify(loadOptions[i])}&`;
              }
            }
          });

          params = params.slice(0, -1);
          let subsistuteParams = params.replace('skip', 'offset');
          subsistuteParams = subsistuteParams.replace(
            'take',
            'limit'
          );

          const offsetLimit = subsistuteParams.split('&');
          const offset = offsetLimit[0].split('=')[1];

          const limit = offsetLimit[1].split('=')[1];

          paramFilters.offset = offset;
          paramFilters.limit = limit;

          const sortParams = await dispatch(
            'filter/applySort',
            {
              sortSettings,
              isFilter: true,
            },
            { root: true }
          );

          paramFilters.ordering = sortParams.sort;

          // return dispatch('getAlerts', paramFilters);

          const result = await dispatch('getAlerts', paramFilters);

          result.data.forEach((item) => {
            if (
              item.created_at &&
              typeof item.created_at === 'string'
            ) {
              item.created_at = new Date(
                item.created_at.replace(
                  /(\d{2})\/(\d{2})\/(\d{4})/,
                  '$3-$2-$1'
                )
              );
            }

            if (
              item.updated_at &&
              typeof item.updated_at === 'string'
            ) {
              item.updated_at = new Date(
                item.updated_at.replace(
                  /(\d{2})\/(\d{2})\/(\d{4})/,
                  '$3-$2-$1'
                )
              );
            }
          });

          return result;
        },
        update(key, val) {
          if (key === 'status') {
            return dispatch('updateAlertState', val);
          }

          return null;
        },
      });
    },
    async getSampleAttributeList({ rootState }, attribute) {
      try {
        const xhr = await Api.getSampleAlertAttributeList(
          attribute,
          rootState.contact.company,
          rootState.contact.address
        );

        const response = JSON.parse(xhr.response);

        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async getSampleReportAttributeList({ rootState }, attribute) {
      try {
        const xhr = await Api.getSampleAlertReportAttributeList(
          attribute,
          rootState.contact.company,
          rootState.contact.address
        );

        const response = JSON.parse(xhr.response);

        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    setReportFocusedRowKey({ commit }, value) {
      commit('setReportFocusedRowKey', value);
    },
    callStoreWithFilters({ commit }, params) {
      EventBus.$emit('AlertsSamplePage', params);
    },
    callReportStoreWithFilters({ commit }, params) {
      EventBus.$emit('AlertsSampleReportsPage', params);
    },
    clearFilteredDataSettings({ commit }, params) {
      EventBus.$emit('AlertsSamplePage', params);
    },
    clearFilteredDataReport({ commit }, params) {
      EventBus.$emit('AlertsSampleReportsPage', params);
    },
    setShowReportPopup({ commit }, value) {
      commit('setShowReportPopup', value);
    },
    setFocusedRowKey({ commit }, value) {
      commit('setFocusedRowKey', value);
    },
  },
  mutations: {
    setShowReportPopup(state, value) {
      state.showReportPopup = value;
    },
    setFocusedRowKey(state, value) {
      state.focusedRowKey = value;
    },
    setReportFocusedRowKey(state, value) {
      state.focusedReportRowKey = value;
    },
  },
};
